import PermissionsService from "../../services/permissions.service";


const state = {
    Permissions: [],
};
const mutations = {
    set_permissions(state, payload) {
        state.AirportsList = payload;
    },

};
const actions = {
    async GetPermissions() {

        const airports = await PermissionsService.GetPermissionsService();
        return airports
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
